// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "passengerOptions__wrapper-1_cxP";
export { _1 as "__esModule", _2 as "passengerOptions__wrapper" }
export default { "__esModule": _1, "passengerOptions__wrapper": _2 }
